export const MIN_SEARCH_LENGTH = 3;
export const SEARCH_DEBOUNCE_MS = 400;
export const SECURITY_IDENTIFIER_DROPDOWN_MIN_WIDTH = 600;

export const SEARCHABLE_FIELDS = ['ticker', 'securityName', 'isin', 'sedol', 'cusip'] as const;
export type SecurityIdentifierField = (typeof SEARCHABLE_FIELDS)[number];

export interface SecurityInput {
  ticker: string | null;
  cusip: string | null;
  isin: string | null;
  sedol: string | null;
  assetClass: string | null;
}

export interface CsvBasketRow {
  SecurityID?: string;
  Isin?: string;
  Sedol?: string;
  Cusip?: string;
  Price?: string;
  Quantity?: string;
  Currency?: string;
  FxRate?: string;
  DivRate?: string;
  AssetClass?: string;
}

export interface SkippedUploadRow {
  rowNumber: number;
  label: string;
  reason: string;
}

export interface BasketUploadRowContext {
  fund: string;
  fundId: string;
  swapCurrency: string;
  tradeDate: string;
}

export interface PendingApiSecurity {
  input: SecurityInput;
  sampleRow: CsvBasketRow;
}

export interface SecurityEnrichmentOptions {
  swapCurrency?: string;
  existingFxRate?: number;
}
